import { atom } from "recoil";
export const previousRouteData = atom({
    key: "previousRouteData", // unique ID (with respect to other atoms/selectors)
    default: { defaultRoute: "/home", activeTab: null }, // default value (aka initial value)
});
